import { Component, ElementRef, Input, OnInit, Output, SecurityContext, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { KeyboardService } from '../../services/keyboard.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends BaseComponent implements OnInit {

  /** @ViewChild
   * @param {ElementRef} eleEditable - input type element instance.
   */
  @ViewChild('text_editable') eleEditable: ElementRef;

  /** @strPlaceholder - set placeholder attribute value of an editable element.
   */
  @Input() strPlaceholder: string;

  constructor(private elem: ElementRef, private sanitizer: DomSanitizer, private keyboardService: KeyboardService) {
    super(elem);
    this.strPlaceholder = '';
   }

  ngOnInit() {
  }

  /** @onKeyPress - method - manipulate user input
   */
  onKeyPress(event: any): boolean {

    let inputcode: number = event.charCode;

    if (inputcode === 0) {
      inputcode = event.keyCode;
    }

    this.setText(event.target.value);

    return this.keyboardService.validateInput(
      event.key, inputcode, event.shiftKey, event.altKey, event.ctrlKey, 0);

  }


  onKeyDown(event: any): boolean {
    if (KeyboardService.isIE) {
      if (event.keyCode === 38) {
        this.setText((parseInt(event.target.value, 10) + 1).toString());
        return false;
      } else if (event.keyCode === 40) {
        this.setText((parseInt(event.target.value, 10) - 1).toString());
        return false;
      }
    }
    return true;
  }

  /** sets text and emits input changed event.
   * @param  {string} value
   */
  setText(value: string) {
    const newVal = value;

    if (value !== this.text) {
      this.text = value;
      this.inputChanged.emit(value);
    }
  }

  getText(): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.text);
  }

  getBypassSecurityTrustHtml() {
    const afterException = this.text;
    const sanitizedText =
      this.sanitizer.sanitize(SecurityContext.HTML, afterException.replace(/\n/g, '<br />').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
    return sanitizedText.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/textarea/textarea.component.ts